/* -----------------Helpers & Hooks--------------- */
import { useDevice } from "@hooks/useDevice";
/* -----------------UI--------------- */
import { Redirect } from "expo-router";
import { useFocusEffect } from "expo-router";
import { useCallback } from "react";

import { AppBottomTabs } from "@features/dashboard/layouts/AppBottomTabs";
import { AppDrawer } from "@features/dashboard/layouts/AppDrawer";
/* -----------------Types--------------- */
import { replayManager } from "@helpers/lib/sentry";
import { isWeb } from "@helpers/platform";
import useAuthUser from "@hooks/useAuthUser";
import { CommandBarProviderWrapper } from "components/CommandBarProviderWrapper";

const DashboardLayout = () => {
	const { isMobile } = useDevice();
	const { isSignedIn, isLoaded } = useAuthUser();

	useFocusEffect(
		useCallback(() => {
			replayManager().stopReplay();
		}, []),
	);

	if (isLoaded && !isSignedIn) {
		return <Redirect href="/" />;
	}

	return (
		<CommandBarProviderWrapper>
			{isMobile && !isWeb ? <AppBottomTabs /> : <AppDrawer />}
		</CommandBarProviderWrapper>
	);
};

export default DashboardLayout;
